import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  useDeviceLanguage,
  connectAuthEmulator
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAr4sjrnIlc2oUtJfGr2QOJDu2LQTLWyvw',
  authDomain: 'speech-path-group.firebaseapp.com',
  projectId: 'speech-path-group',
  storageBucket: 'speech-path-group.appspot.com',
  messagingSenderId: '948104656867',
  appId: '1:948104656867:web:b576c88c22bc5228d692d6',
  measurementId: 'G-19TEQ06L1W',
};

const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

// Emulator connection
if (typeof window !== 'undefined' && window.location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://localhost:9099");
}

// ✅ Auth setup
setPersistence(auth, browserLocalPersistence) // Use LOCAL for cross-subdomain
  .then(() => console.log("[FIREBASE] Persistence set to LOCAL"))
  .catch((err) => console.error('[FIREBASE] Persistence error:', err));

useDeviceLanguage(auth);

// 🔑 CRITICAL: Set domain for cross-subdomain auth
auth.settings.domain = 'alydmarket.com'; // Root domain without dot

// Testing setting (optional)
auth.settings.appVerificationDisabledForTesting = true; 

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { firebaseApp as default, auth, db, storage };